import { render, staticRenderFns } from "./ListArtInfo.vue?vue&type=template&id=6095b6e3&"
import script from "./ListArtInfo.vue?vue&type=script&lang=js&"
export * from "./ListArtInfo.vue?vue&type=script&lang=js&"
import style0 from "./ListArtInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports